<template>
  <article class="CardConfirmarPedido w-100">
    <div class="card">
      <div
        class="card-body m-5 p-5 text-black-50 text-center text-uppercase"
        v-if="!pedido"
      >
        <h5>Carregando as informações do seu carrinho</h5>
        <div class="spinner-grow" style="width: 3rem; height: 3rem;">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="card-body row" v-else>
        <section class="col-12 col-lg-7">
          <strong style=" font-size: 1.3em; color: #707070;">Seus dados</strong>
          <hr />
          <p class="mb-1">{{ $store.state.dadosPessoais.cliente.nome }}</p>
          <p class="mb-1">{{ $store.state.dadosPessoais.cliente.cpf }}</p>
          <p class="mb-1">
            {{ $store.state.dadosPessoais.cliente.dataNascimento }}
          </p>
          <p class="mb-1">{{ $store.state.dadosPessoais.cliente.celular }}</p>
          <p class="mb-1">{{ $store.state.dadosPessoais.cliente.email }}</p>
          <div class="mb-1">
            <small class="text-black-50 font-weight-bold"
              >Endereco de cobrança</small
            >
            <p
              v-if="$store.state.dadosPessoais.enderecoIguais"
              class="text-black-50"
            >
              O endereço de entrega é igual ao meu endereço de cobrança
            </p>
            <p v-else>
              {{ endereco($store.state.dadosPessoais.cliente.endereco) }}
            </p>
          </div>
        </section>
        <section class="col-12 col-lg-5">
          <strong style=" font-size: 1.3em; color: #707070;"
            >Endereco de entrega</strong
          >
          <hr />
          <p>
            {{ endereco($store.state.dadosPessoais.enderecoEntrega) }}
          </p>
        </section>
        <section class="col-12 mt-4">
          <strong style=" font-size: 1.3em; color: #707070;"
            >Carrinho de compras</strong
          >
          <hr />
          <ul class="border-bottom pb-3 list-unstyled">
            <li
              v-for="(item, index) of this.pedido.itens"
              :key="index"
              class="d-flex pb-4"
            >
              <img
                class="img-thumbnail mr-2"
                v-if="item.produto.imagemList"
                :src="
                  item.produto.imagemList[0].urlImagem ||
                    'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png'
                "
                :alt="item.produto.nome"
                style="max-width: 123px;"
              />
              <div class="d-flex w-100 justify-content-between">
                <div class="d-flex flex-column">
                  <strong class="font-size-1-5">{{ item.produto.nome }}</strong>
                  <small class="text-muted">{{ item.produto.descricao }}</small>
                </div>
                <div class="text-right mt-2 d-flex flex-column">
                  <span class="text-muted"
                    >{{ item.quantidade }}x
                    {{ item.produto.valorUnitario | currency }}</span
                  >
                  <span
                    class="align-middle ml-4 text-right"
                    style="font-size: 1.3em;"
                  >
                    {{
                      (item.quantidade * item.produto.valorUnitario) | currency
                    }}
                  </span>
                </div>
              </div>
            </li>
          </ul>
          <div class="float-right">
            <div class="d-flex justify-content-between">
              <small class="pr-5">Subtotal</small>
              <strong>{{ this.pedido.valorCompra | currency }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <small class="pr-5">Taxa de entrega</small>
              <strong>{{
                !this.pedido.valorFrete
                  ? "Grátis"
                  : this.pedido.valorFrete | currency
              }}</strong>
            </div>
            <div class="d-flex justify-content-between font-size-1-5">
              <span class="pr-5">Total</span>
              <strong>{{ this.pedido.valorTotal | currency }}</strong>
            </div>
          </div>
          <span class="clearfix"></span>
        </section>
        <section class="col-12 mt-4" v-if="quantidadeMaximaParcelasConfig">
          <strong style=" font-size: 1.3em; color: #707070;"
            >Parcelamento</strong
          >
          <hr />
          <label class="mt-3">Selecione a quantidade de parcelas</label>
          <select v-model="quantidadeParcelas" class="form-control mb-5">
            <option
              v-for="(parcelas, index) of parcelas"
              :key="index"
              :value="parcelas.nParcelas"
              >Em {{ parcelas.nParcelas }}x de
              {{ parcelas.valorParcelas | currency }} sem juros</option
            >
          </select>
        </section>
        <section v-if="loading" class="loading">
          <div
            class="align-items-center d-flex flex-column h-100 justify-content-center text-white"
          >
            <h4 class="px-4">Processando seu carrinho de compras</h4>
            <div class="spinner-grow" style="width: 3rem; height: 3rem;">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="mt-3 mb-5 px-3 row justify-content-between">
      <button
        class="btn btn-secondary px-5 mt-4 py-2"
        @click="goToStep('dados')"
      >
        VOLTAR
      </button>
      <button
        class="btn btn-primary py-2 px-5 mt-4"
        @click="realizarCheckout()"
      >
        FINALIZAR PEDIDO
      </button>
    </div>
  </article>
</template>
<script>
import { enderecoNoWrap } from "../shared/helpers/helpers";
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "CardConfirmarPedido",
  props: {},
  components: {},
  data() {
    return {
      loading: false,
      pedido: null,
      quantidadeParcelas: 1,
      quantidadeMaximaParcelasConfig: null,
      parcelas: []
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.$moment.locale("pt-br");
    const obj = {
      redeLoja: {
        codigoLoja: this.$store.state.pedido.itens[0].produto.redeLoja
          .codigoLoja
      },
      itens: this.$store.state.pedido.itens
    };

    apiService.cadastrarPedido(obj).then(response => {
      this.pedido = response;
    });
  },
  methods: {
    realizarCheckout() {
      this.loading = true;
      const objCheckout = this.$store.state.dadosPessoais;
      objCheckout.pedido = {
        codigoReferencia: this.pedido.codigoReferencia,
        quantidadeParcelas: this.quantidadeParcelas
      };
      objCheckout.cliente.dataNascimento = new Date(
        `${objCheckout.cliente.dataNascimento.split("/")[1]}/${
          objCheckout.cliente.dataNascimento.split("/")[0]
        }/${objCheckout.cliente.dataNascimento.split("/")[2]}`
      );
      objCheckout.cliente.cpf = objCheckout.cliente.cpf.replace(/\.|-/g, "");
      objCheckout.cliente.endereco.pais = "BR";
      apiService
        .checkout(objCheckout)
        .then(response => {
          this.$store.state.pedido.codigoPagamento = response.codigoPagamento;
          this.$store.state.pedido.codigoCartao = response.codigoCartao;
          this.$store.state.pedido.url = response.url;
          this.goToStep("pagamento");
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    adicionar(evt, produto) {
      const objDetalhes = {
        produto,
        quantidade: 1
      };
      const action = evt ? "pedidoAdicionarProduto" : "pedidoRemoverProduto";
      this.$store.dispatch(action, objDetalhes);
    },
    endereco(end) {
      return enderecoNoWrap(end);
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    },
    parcelasConfig() {
      this.parcelas = [];
      let nParcelas = 1;
      this.quantidadeMaximaParcelasConfig = this.quantidadeMaximaParcelasConfig.sort(
        (a, b) => b.valorPagamento - a.valorPagamento
      );
      this.quantidadeMaximaParcelasConfig.forEach(e => {
        if (this.pedido.valorTotal > e.valorPagamento) {
          while (nParcelas <= e.quantidadeMaximaParcelas) {
            this.parcelas.push({
              nParcelas: nParcelas,
              valorParcelas: +(this.pedido.valorTotal / nParcelas).toFixed(2)
            });
            nParcelas++;
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btn-quantidade {
  width: 30px;
  height: 30px;
  border-radius: 50px;
  padding: 0.2em 0.35em;
}
.card {
  border-radius: 0 0 0.25rem 0.25rem;
}
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
}
</style>
